<div #tooltip class="tooltip">
  <h1>{{ title }}</h1>
  <div class="body" [innerHTML]="body"></div>
</div>
<div #arrow class="arrow-{{ getArrowClass() }}"></div>
